import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader, Bullets, Note } from "@/components/Bits";

const BULLETS = [
  "Discover businesses near you",
  "Order ahead or scan a table QR",
  "Split the bill (whole/your items/evenly/by item)",
  "Tip (100% to workers)",
  "Pay by card, Apple Pay, or Google Pay (where available)",
  "Earn dollar rewards",
  "Birthday rewards where offered (we never share your full birthday)",
  "Reserve or join a waitlist",
  "Receipts & activity in one place",
];

const Customers = () => {
  useSeo({
    title: "Customers",
    description: "From finding a place to paying your share, MONOE brings local commerce into a single, simple flow.",
    path: "/customers",
  });

  return (
    <div>
      <PageHeader
        eyebrow="For customers"
        title="Everything local, in one app."
        intro="From finding a place to paying your share, MONOE brings local commerce into a single, simple flow."
        testId="customers-hero"
      />
      <section>
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <Reveal>
            <Bullets items={BULLETS} testId="customers-bullets" />
          </Reveal>
          <Reveal delay={0.05}>
            <Note testId="customers-rewards-note">
              MONOE Rewards are dollars, not points — and they aren't money stored in MONOE. There is
              no MONOE wallet.
            </Note>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Customers;
